import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';
class default_1 extends Component {
    constructor(props) {
        super(props);
        this.handleToggleSection = () => this.setState((prevState) => ({ open: !prevState.open }));
        this.state = {
            open: true,
        };
    }
    render() {
        const { title, children } = this.props;
        const { open } = this.state;
        const toggleClassName = classnames({
            fa: true,
            'mr-0': true,
            'font-light': true,
        });
        const filtersClassName = classnames({
            'filters-list': true,
            'px-4': true,
            'pb-4': true,
            hide: !open,
            'border-b': true,
            'border-grey-light': true,
            'border-solid': true,
        });
        return (React.createElement("div", { className: "list-filter-group" },
            React.createElement("div", { className: "heading flex justify-between pt-4 items-center" },
                React.createElement("h4", { className: "text-black text-sm m-0 pl-4" }, title),
                React.createElement("button", { className: "button", onClick: this.handleToggleSection },
                    open && React.createElement(ChevronDownIcon, null),
                    !open && React.createElement(ChevronRightIcon, null),
                    React.createElement("span", { className: toggleClassName }))),
            React.createElement("div", { className: filtersClassName }, children)));
    }
}
default_1.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
};
export default default_1;
